@if (currentEnv === 'DEV' || currentEnv === 'QA') {
<div class="env-banner d-flex align-items-center fw-bold top-0 justify-content-center text-white w-100 gap-2">
  <span class="env-icon" aria-hidden="true">
    @if (currentEnv === 'DEV') {
    <img src="assets/icons/dev.svg" alt="DEV Icon" />
    } @else {
    <img src="assets/icons/qa.svg" alt="QA Icon" />
    }
  </span>
  Du befindest dich auf der {{ currentEnv }} Umgebung
</div>
}

@if (isAuthenticated$ | async) {
<ui-header [links]="links$ | async"></ui-header>
<router-outlet></router-outlet>
}